import React from "react";
import dayjs from "dayjs";
import { DataGridProps } from "../components";
import { makeObservable, observable, action } from "mobx";
import { getHistorys } from "../api/History";
import { UtcDateFormatter } from "../utils/dateformat/dateFormat";
import {
  DetailContainer,
  DetailBox,
  DetailTitle,
  DetailContents,
  NoneWrap,
} from "../pages/History/styles";
import { RejectInfo } from "../commonObj";

import Link from "@mui/material/Link";
import { getTemplatesServerType, getAccountServerType } from "../constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();
const getCooKie = (item: string) => {
  return cookies.get(item);
};

class HistoryStore {
  constructor() {
    makeObservable(this, {
      startDate: observable,
      endDate: observable,
      gridOption: observable,
      searchText: observable,
    });
  }
  nowDate = dayjs().toDate();
  startDate = getCooKie("hStartDate")
    ? getCooKie("hStartDate")
    : dayjs().subtract(1, "month").toDate();
  // startDate = dayjs().subtract(1, "week").toDate();
  endDate = dayjs().toDate();
  searchText = "";

  gridOption: DataGridProps = {
    columns: [
      {
        field: "index",
        headerName: "No",
        filterable: false,
        width: 100,
        align: "center",
        renderCell: (index) =>
          index.api.getRowIndex(index.row.id) +
          1 +
          this.gridOption.page * this.gridOption.rowsPerPage,
      },
      { field: "createdAt", headerName: "Date", width: 250 },
      { field: "ipAddress", headerName: "IP Address", width: 200 },
      {
        field: "details.action",
        headerName: "Action",
        width: 150,
        renderCell: (params) => params.row.details.action,
      },
      { field: "user", headerName: "Edited by", width: 300 },
      {
        field: "details",
        headerName: "Details",
        width: 616,
        renderCell: (params) => {
          if (params.row.details.action === "Get Templated") {
            return (
              <DetailContainer>
                <DetailBox>
                  <DetailTitle>Template Id</DetailTitle>
                  <DetailTitle>Status</DetailTitle>
                  <DetailTitle>Error</DetailTitle>
                </DetailBox>
                <DetailBox>
                  <DetailContents>
                    <Link
                      href={
                        getTemplatesServerType() +
                        "templates/" +
                        params.row.details.templadteId
                      }
                    >
                      {params.row.details.templadteId ?? "-"}
                    </Link>
                  </DetailContents>
                  <DetailContents>
                    {params.row.details.status ?? "-"}
                  </DetailContents>
                  <DetailContents>
                    {params.row.details.error ?? "-"}
                  </DetailContents>
                </DetailBox>
              </DetailContainer>
            );
          }
          if (params.row.details.action === "Reject") {
            if (params.row.details.status === "Error") {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                    <DetailTitle>Error</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.error ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            } else {
              const rejected = params.row.details.rejected;
              const fails = rejected.fails.join(", ");

              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                    <DetailTitle>Reason</DetailTitle>
                    <DetailTitle>Fails</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {RejectInfo[rejected.reason] ?? "-"}
                    </DetailContents>
                    <DetailContents>{fails ?? "-"}</DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            }
          }
          if (params.row.details.action === "Publish") {
            if (params.row.details.status === "Error") {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                    <DetailTitle>Error</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.error ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            } else {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                    <DetailTitle>StartTime</DetailTitle>
                    <DetailTitle>EndTime</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.startTime ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.endTime ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            }
          }
          if (params.row.details.action === "Start Review") {
            if (params.row.details.status === "Error") {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                    <DetailTitle>Error</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.error ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            } else {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            }
          }
          if (params.row.details.action === "Stop Review") {
            if (params.row.details.status === "Error") {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                    <DetailTitle>Error</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.error ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            } else {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            }
          }
          if (params.row.details.action === "Moderation") {
            if (params.row.details.status === "Error") {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                    <DetailTitle>Error</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.error ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            } else {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Scores</DetailTitle>
                    <DetailTitle>Extra Description</DetailTitle>
                    <DetailTitle>Category</DetailTitle>
                    <DetailTitle>Language Code</DetailTitle>
                    <DetailTitle>Region Code</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.scores
                        ? "[Mixability: " +
                          params.row.details.scores.mixability +
                          ", " +
                          "Reference: " +
                          params.row.details.scores.reference +
                          ", " +
                          "Asset: " +
                          params.row.details.scores.asset +
                          ", " +
                          "Entertainment: " +
                          params.row.details.scores.entertainment +
                          "]"
                        : "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.description
                        ? params.row.details.description === ""
                          ? "-"
                          : params.row.details.description
                        : "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.category.category ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.metaLanguageCode ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.metaCountryCode ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            }
          }
          if (params.row.details.action === "Get List") {
            if (params.row.details.status === "Error") {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>Status</DetailTitle>
                    <DetailTitle>Error</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.error ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            }
          }
          if (params.row.details.action === "Modify ParentId") {
            if (params.row.details.status === "Error") {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Parent Id</DetailTitle>
                    <DetailTitle>Status</DetailTitle>
                    <DetailTitle>Error</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.parentId ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.status ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.error ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            } else {
              return (
                <DetailContainer>
                  <DetailBox>
                    <DetailTitle>User Id</DetailTitle>
                    <DetailTitle>User Ncikname</DetailTitle>
                    <DetailTitle>Template Id</DetailTitle>
                    <DetailTitle>Parent Id</DetailTitle>
                  </DetailBox>
                  <DetailBox>
                    <DetailContents>
                      <Link
                        href={
                          getAccountServerType() +
                          "/" +
                          params.row.details.userId
                        }
                      >
                        {params.row.details.userId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.userName ?? "-"}
                    </DetailContents>
                    <DetailContents>
                      <Link
                        href={
                          getTemplatesServerType() +
                          "templates/" +
                          params.row.details.templadteId
                        }
                      >
                        {params.row.details.templadteId ?? "-"}
                      </Link>
                    </DetailContents>
                    <DetailContents>
                      {params.row.details.parentId ?? "-"}
                    </DetailContents>
                  </DetailBox>
                </DetailContainer>
              );
            }
          }
          if (params.row.details.action === "Blind") {
            return (
              <DetailContainer>
                <DetailBox>
                  <DetailTitle>User Id</DetailTitle>
                  <DetailTitle>User Ncikname</DetailTitle>
                  <DetailTitle>Template Id</DetailTitle>
                  <DetailTitle>Status</DetailTitle>
                </DetailBox>
                <DetailBox>
                  <DetailContents>
                    <Link
                      href={
                        getAccountServerType() + "/" + params.row.details.userId
                      }
                    >
                      {params.row.details.userId ?? "-"}
                    </Link>
                  </DetailContents>
                  <DetailContents>
                    {params.row.details.userName ?? "-"}
                  </DetailContents>
                  <DetailContents>
                    <Link
                      href={
                        getTemplatesServerType() +
                        "templates/" +
                        params.row.details.templadteId
                      }
                    >
                      {params.row.details.templadteId ?? "-"}
                    </Link>
                  </DetailContents>
                  <DetailContents>
                    {params.row.details.status ?? "-"}
                  </DetailContents>
                </DetailBox>
              </DetailContainer>
            );
          }
          if (params.row.details.action === "Unblind") {
            return (
              <DetailContainer>
                <DetailBox>
                  <DetailTitle>User Id</DetailTitle>
                  <DetailTitle>User Ncikname</DetailTitle>
                  <DetailTitle>Template Id</DetailTitle>
                  <DetailTitle>Status</DetailTitle>
                </DetailBox>
                <DetailBox>
                  <DetailContents>
                    <Link
                      href={
                        getAccountServerType() + "/" + params.row.details.userId
                      }
                    >
                      {params.row.details.userId ?? "-"}
                    </Link>
                  </DetailContents>
                  <DetailContents>
                    {params.row.details.userName ?? "-"}
                  </DetailContents>
                  <DetailContents>
                    <Link
                      href={
                        getTemplatesServerType() +
                        "templates/" +
                        params.row.details.templadteId
                      }
                    >
                      {params.row.details.templadteId ?? "-"}
                    </Link>
                  </DetailContents>
                  <DetailContents>
                    {params.row.details.status ?? "-"}
                  </DetailContents>
                </DetailBox>
              </DetailContainer>
            );
          }

          return <NoneWrap>None</NoneWrap>;
        },
      },
    ],
    rows: [],
    totalCount: 0,
    loading: true,
    page: 0,
    rowsPerPage: 20,
  };

  setStartDate = action((startDate: Date) => {
    this.startDate = startDate;
  });

  setEndDate = action((endDate: Date) => {
    this.endDate = endDate;
  });

  onPageSizeChange = action((params: any) => {
    window.scrollTo(0, 0);
    this.gridOption.rowsPerPage = params;
  });

  onPageChange = action((params: any) => {
    window.scrollTo(0, 0);
    this.gridOption.page = params;
  });

  setGridOption = action((gridOption: any) => {
    this.gridOption = {
      ...this.gridOption,
      ...gridOption,
    };
  });
  setSearchText = action((searchText: string) => {
    if (searchText.slice(0, 1) !== " ") {
      this.searchText = searchText;
    }
  });

  setRows = action(async () => {
    const requestParameter = {
      page: this.gridOption.page + 1,
      display: this.gridOption.rowsPerPage,
      startedAt: this.startDate,
      endedAt: this.endDate,
      searchText: this.searchText,
    };
    this.gridOption.loading = true;
    this.gridOption.rows = [];
    await getHistorys(
      "",
      requestParameter.startedAt,
      requestParameter.endedAt,
      requestParameter.page,
      requestParameter.display,
      requestParameter.searchText
    )
      .then((data) => {
        // Axios 는 실패해도 throw 하지 않고 에러 객체를 그대로 반환한다.
        // 정상 응답에만 있는 필드로 판별해 catch 로 넘긴다.
        if (!data?.history) {
          throw data;
        }
        this.setGridOption({
          totalCount: data.totalCount,
          rows: data.history.map((info: any) => {
            return {
              ...info,
              id: info.historyId,
              createdAt: UtcDateFormatter(info.createdAt),
            };
          }),
        });
      })
      .catch((error) => {
        console.log("error", error);
        this.gridOption.totalCount = 0;
        const status = error?.response?.status;
        alert(
          `Failed to load the history list.${status ? ` (code: ${status})` : ""}`
        );
      })
      .finally(() => {
        this.gridOption.loading = false;
      });
  });

  searchHandler = action(async () => {
    // 검색어 없을시 모달을 띄울것인가?
    this.gridOption.page = 0;
    await this.setRows();
  });
}

export default HistoryStore;
